import React, { Component } from "react";
import {
  List
} from "semantic-ui-react";
import * as moment from 'moment';

import Firebase from './Firebase';
import { Link } from 'react-router-dom';
import ErrorDisplay from './ErrorDisplay';

function formatTimestamp(timestamp){
  var newTime = moment(timestamp.toDate());
  newTime.utcOffset(-300);
  return newTime.format("MMM D/YY, h:mm a");
}

export default class AdminDashboard extends Component {
  constructor(props){
    super(props);

    this.state = {
      books: null,
      errorMsg: null
    };

  }

  componentDidMount() {
    var db = Firebase.getFirestore();

    db.collection("books").orderBy("date", "desc")
      .onSnapshot((snapshot) => {
          var bookList = [];
          snapshot.forEach((doc) => {
              var data = doc.data();
              data.id = doc.id;
              bookList.push(data);
          });
          this.setState({ books: bookList });
      }, (err) => {
        this.setState({ errorMsg: "Error getting books : " + err.message });
      });
  }

  render() {
    if(this.state.errorMsg){
      return <ErrorDisplay message={this.state.errorMsg} />;
    }else if(this.state.books){
      return (
        <List>
          { this.state.books.map( (book) =>
            (<List.Item key={book.id}>
              <List.Icon name='book' />
              <List.Content>
                <Link to={"/admin/book/" + book.id}>
                  <List.Header>{formatTimestamp(book.date) + " - " + book.name}</List.Header>
                </Link>
                <List.Description>
                  {book.email + " - " + book.telephone}
                </List.Description>
              </List.Content>
            </List.Item>)
          )}
        </List>
      );
    }else{
      return (
        "No Submission"
      )
    }
  }
}
